(function () {
  'use strict';
  var PX = 'wl';
  function T() { return window.Theme; }
  function words() { var el = document.getElementById(PX + '-ui-strings'); try { return el ? JSON.parse(el.textContent) : {}; } catch (e) { return {}; } }
  function money(c) { try { return T().money.format(c); } catch (e) { return '$' + (Number(c || 0) / 100).toFixed(2); } }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (ch) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[ch]; }); }
  function pic(src, w) {
    if (!src) return '<span class="' + PX + '-ui__ph" aria-hidden="true"></span>';
    var u = /^data:/.test(src) ? src : src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + (w * 2);
    return '<img src="' + esc(u) + '" alt="" width="' + w + '" height="' + w + '" loading="lazy">';
  }
  function count(n, W) { return n + ' ' + (n === 1 ? (W.item_one || 'item') : (W.item_other || 'items')); }
  function cartUrl() { return (T() && T().routes && T().routes.cart) || '/cart'; }
  function checkoutUrl() { return (T() && T().routes && T().routes.checkout) || '/checkout'; }
  var lastAdded = null, lastFocus = null;
  function trap(box, e) {
    if (e.key !== 'Tab') return;
    var f = box.querySelectorAll('a[href], button:not([disabled]), input, [tabindex]:not([tabindex="-1"])'); if (!f.length) return;
    var a = f[0], z = f[f.length - 1];
    if (e.shiftKey && document.activeElement === a) { e.preventDefault(); z.focus(); } else if (!e.shiftKey && document.activeElement === z) { e.preventDefault(); a.focus(); }
  }
  function start(fn) { if (window.Theme && window.Theme.events) fn(); else document.addEventListener('DOMContentLoaded', function () { if (window.Theme) fn(); }); }

  var D = document, H = D.documentElement, A = 'addEventListener', R = 'removeEventListener';
  H.classList.add('wl-js');
  function still() { return !!(window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches); }
  function phone() { return window.matchMedia ? matchMedia('(max-width: 749px)') : { matches: false }; }
  function desk() { return window.matchMedia ? matchMedia('(min-width: 990px)').matches : true; }
  function def(n, c) { if (!customElements.get(n)) customElements.define(n, c); }
  function raf(fn) { var q = 0; return function () { if (q) return; q = requestAnimationFrame(function () { q = 0; fn(); }); }; }
  function keep(k, v) { try { if (v === undefined) return localStorage.getItem(k); localStorage.setItem(k, v); } catch (e) { /* private mode: the toggle still works for this visit */ } return null; }
  function paused() { return H.hasAttribute('data-wl-pause'); }
  function sm(x) { x = Math.max(0, Math.min(1, x)); return x * x * (3 - 2 * x); }

  /* ------------------------------------------------------------------ <wl-reveal> */
  def('wl-reveal', class extends HTMLElement {
    connectedCallback() {
      var s = this;
      if (!('IntersectionObserver' in window)) { s.classList.add('is-in'); return; }
      this.io = new IntersectionObserver(function (es) { if (es[0].isIntersecting) { s.classList.add('is-in'); s.io.disconnect(); } }, { rootMargin: '0px 0px -8% 0px' });
      this.io.observe(this);
    }
    disconnectedCallback() { if (this.io) this.io.disconnect(); }
  });

  /* ------------------------------------------------------------------ <wl-atelier>: the hero's "Pause motion" toggle and the loop that pauses off-screen */
  def('wl-atelier', class extends HTMLElement {
    connectedCallback() {
      var s = this, b = this.querySelector('[data-wl-pausebtn]');
      function mark(v) { H.toggleAttribute('data-wl-pause', v); if (b) b.setAttribute('aria-pressed', v ? 'true' : 'false'); }
      mark(keep('wl-pause') === '1');
      this.tog = function () { var v = !paused(); mark(v); keep('wl-pause', v ? '1' : '0'); };
      if (b) b[A]('click', this.tog);
      if ('IntersectionObserver' in window) {
        this.io = new IntersectionObserver(function (es) { es.forEach(function (e) { e.target.classList.toggle('is-away', !e.isIntersecting); }); });
        [].forEach.call(this.querySelectorAll('.wl-loop'), function (l) { s.io.observe(l); });
      }
    }
    disconnectedCallback() { if (this.io) this.io.disconnect(); }
  });

  /* ------------------------------------------------------------------ <wl-eta>: Order today, estimated delivery Tue, Oct 13 - Fri, Oct 16 */
  def('wl-eta', class extends HTMLElement {
    connectedCallback() {
      var v = this.querySelector('[data-eta]'); if (!v) return;
      function add(n) { var d = new Date(), w; while (n > 0) { d.setDate(d.getDate() + 1); w = d.getDay(); if (w !== 0 && w !== 6) n--; } return d; }
      try {
        var f = { weekday: 'short', month: 'short', day: 'numeric' };
        v.textContent = add(7).toLocaleDateString('en-US', f) + ' – ' + add(10).toLocaleDateString('en-US', f);
        this.setAttribute('data-ready', '');
      } catch (e) { /* the written fallback stays */ }
    }
  });

  /* ------------------------------------------------------------------ <wl-pill>: the sticky buy pill on phones */
  def('wl-pill', class extends HTMLElement {
    connectedCallback() {
      var s = this, t = D.querySelector('[data-wl-hero-add]');
      if (!t || !('IntersectionObserver' in window)) return;
      H.classList.add('wl-has-pill');
      this.past = false; this.on = {};
      var ends = [].slice.call(D.querySelectorAll('.site-footer, .wl-final'));
      this.io = new IntersectionObserver(function (es) { es.forEach(function (e) { s.past = !e.isIntersecting && e.boundingClientRect.top < 0; }); s.apply(); });
      this.io.observe(t);
      this.io2 = new IntersectionObserver(function (es) { es.forEach(function (e) { s.on[ends.indexOf(e.target)] = e.isIntersecting; }); s.apply(); });
      ends.forEach(function (e) { s.io2.observe(e); });
    }
    apply() {
      var end = Object.keys(this.on).some(function (k) { return this.on[k]; }, this), on = this.past && !end;
      this.classList.toggle('is-in', on);
      if (on) { this.removeAttribute('aria-hidden'); this.removeAttribute('inert'); } else { this.setAttribute('aria-hidden', 'true'); this.setAttribute('inert', ''); }
    }
    disconnectedCallback() { if (this.io) this.io.disconnect(); if (this.io2) this.io2.disconnect(); H.classList.remove('wl-has-pill'); }
  });

  /* ------------------------------------------------------------------ <wl-spy>: in-page anchors, smooth scroll, "current" chip */
  function anchorId(a) {
    var h = a.getAttribute('href') || '', i = h.lastIndexOf('#');
    if (i < 0 || i === h.length - 1) return '';
    var id = h.slice(i + 1), base = h.slice(0, i).replace(/^#/, '');
    if (!id || id.charAt(0) === '/') return '';
    if (base && base !== '/' && base !== location.pathname) return '';
    return id;
  }
  def('wl-spy', class extends HTMLElement {
    connectedCallback() {
      var s = this; this._on = {}; this._cur = '';
      this._click = function (e) {
        if (e.defaultPrevented || e.button > 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
        var a = e.target.closest ? e.target.closest('a[href]') : null, id = a && anchorId(a), t = id && D.getElementById(id); if (!t) return;
        e.preventDefault();
        t.scrollIntoView({ behavior: still() ? 'auto' : 'smooth', block: 'start' });
        try { history.replaceState(null, '', '#' + id); } catch (x) { /* the page still scrolled */ }
        if (!t.hasAttribute('tabindex')) t.setAttribute('tabindex', '-1');
        try { t.focus({ preventScroll: true }); } catch (x) { /* old browsers */ }
      };
      D[A]('click', this._click);
      this.links = [];
      [].forEach.call(D.querySelectorAll('.wl-chip'), function (a) { var id = anchorId(a), el = id && D.getElementById(id); if (el) s.links.push({ a: a, id: id, el: el }); });
      if (!this.links.length || !('IntersectionObserver' in window)) return;
      var vh = window.innerHeight, hero = D.querySelector('.wl-hero');
      this._io = new IntersectionObserver(function (es) {
        es.forEach(function (en) { s._on[en.target.id] = en.isIntersecting; });
        var cur = ''; s.links.forEach(function (l) { if (s._on[l.id]) cur = l.id; });
        if (!cur && s._cur && window.pageYOffset > 40 && !(hero && s._on[hero.id])) cur = s._cur;   /* between two sections keep the last one; back in the hero: none */
        s._cur = cur;
        s.links.forEach(function (l) { var on = l.id === cur; l.a.classList.toggle('is-current', on); if (on) l.a.setAttribute('aria-current', 'location'); else if (l.a.getAttribute('aria-current') === 'location') l.a.removeAttribute('aria-current'); });
      }, { rootMargin: '-' + Math.round(vh * 0.2) + 'px 0px -' + Math.round(vh * 0.5) + 'px 0px' });
      this.links.forEach(function (l) { s._io.observe(l.el); });
      if (hero) this._io.observe(hero);
    }
    disconnectedCallback() { D[R]('click', this._click); if (this._io) this._io.disconnect(); }
  });

  /* ------------------------------------------------------------------ the full-screen photo viewer (tap a photo; swipe, arrows, Esc / tap to close, double-tap = 2x zoom) */
  var vw = null;
  function viewList() {
    var a = [].slice.call(D.querySelectorAll('[data-wl-strip] [data-full]')).map(function (b) { return { src: b.getAttribute('data-full'), alt: b.getAttribute('data-alt') || '' }; });
    if (a.length) return a;
    return [].slice.call(D.querySelectorAll('.gallery__image-wrap[data-zoom-src]')).map(function (w) { var i = w.querySelector('img'); return { src: w.getAttribute('data-zoom-src'), alt: i ? i.alt : '' }; });
  }
  function viewer() {
    if (vw && D.body.contains(vw.el)) return vw;
    var W = words(), el = D.createElement('div');
    el.className = 'wl-view'; el.setAttribute('role', 'dialog'); el.setAttribute('aria-modal', 'true'); el.setAttribute('aria-hidden', 'true'); el.setAttribute('aria-label', W.v_label || 'Photo viewer');
    el.innerHTML = '<div class="wl-view__bar"><p class="wl-view__count" aria-live="polite"></p><button type="button" class="wl-view__x" data-v="close" aria-label="' + esc(W.v_close || 'Close') + '">' + icon('x', 22) + '</button></div>' +
      '<div class="wl-view__stage" data-v="stage"><img class="wl-view__img" alt="" draggable="false"></div>' +
      '<button type="button" class="wl-view__nav wl-view__nav--prev" data-v="prev" aria-label="' + esc(W.v_prev || 'Previous photo') + '">' + icon('left', 24) + '</button>' +
      '<button type="button" class="wl-view__nav wl-view__nav--next" data-v="next" aria-label="' + esc(W.v_next || 'Next photo') + '">' + icon('right', 24) + '</button>' +
      '<p class="wl-view__hint">' + esc(W.v_hint || '') + '</p>';
    var st = el.querySelector('[data-v="stage"]'), im = el.querySelector('.wl-view__img'), ct = el.querySelector('.wl-view__count'), xb = el.querySelector('.wl-view__x');
    var S = { i: 0, list: [], z: 1, tx: 0, ty: 0, opener: null }, P = null, last = { t: 0, x: 0, y: 0 }, timer = 0;
    function put(anim) { im.style.transition = anim ? '' : 'none'; im.style.transform = 'translate3d(' + S.tx + 'px,' + S.ty + 'px,0) scale(' + S.z + ')'; }
    function lim(k) { return Math.max(0, (S.z - 1) * (k ? im.offsetHeight : im.offsetWidth) / 2); }
    function clamp(v, k) { var m = lim(k); return Math.max(-m, Math.min(m, v)); }
    function unzoom() { S.z = 1; S.tx = 0; S.ty = 0; el.classList.remove('is-zoom'); put(true); }
    function show(i, dir) {
      var n = S.list.length; if (!n) return;
      S.i = (i + n) % n; S.z = 1; S.tx = 0; S.ty = 0; el.classList.remove('is-zoom');
      var it = S.list[S.i];
      if (dir && !still()) { im.style.transition = 'none'; im.style.opacity = '0'; im.style.transform = 'translate3d(' + (dir * 46) + 'px,0,0)'; }
      im.src = it.src; im.alt = it.alt; ct.textContent = (S.i + 1) + ' / ' + n; ct.setAttribute('aria-label', 'Photo ' + (S.i + 1) + ' / ' + n);
      requestAnimationFrame(function () { requestAnimationFrame(function () { im.style.opacity = ''; put(true); }); });
      try { var nx = new Image(); nx.src = S.list[(S.i + 1) % n].src; } catch (e) { /* preloading is optional */ }
    }
    function go(d) { clearTimeout(timer); show(S.i + d, d); }
    function zoomAt(x, y) {
      if (S.z > 1) { unzoom(); return; }
      var r = im.getBoundingClientRect(); S.z = 2; S.tx = 0; S.ty = 0;
      S.tx = clamp(-(x - (r.left + r.width / 2)), 0); S.ty = clamp(-(y - (r.top + r.height / 2)), 1);
      el.classList.add('is-zoom'); put(true);
    }
    function tap(x, y, onImg) {
      if (!onImg) { shut(); return; }                       /* a tap on the dark backdrop closes at once */
      var now = Date.now();
      if (now - last.t < 320 && Math.abs(x - last.x) < 40 && Math.abs(y - last.y) < 40) { clearTimeout(timer); last.t = 0; zoomAt(x, y); return; }
      last = { t: now, x: x, y: y }; clearTimeout(timer);
      timer = setTimeout(function () { if (S.z > 1) unzoom(); else shut(); }, 320);   /* one tap = close (zoomed: back to 1x), unless a second tap follows */
    }
    st[A]('pointerdown', function (e) {
      if (e.pointerType === 'mouse' && e.button !== 0) return;
      P = { id: e.pointerId, x: e.clientX, y: e.clientY, t: Date.now(), dx: 0, dy: 0, moved: false, tx: S.tx, ty: S.ty, img: e.target === im };
      try { st.setPointerCapture(e.pointerId); } catch (x) { /* the move events still arrive */ }
    });
    st[A]('pointermove', function (e) {
      if (!P || e.pointerId !== P.id) return;
      P.dx = e.clientX - P.x; P.dy = e.clientY - P.y;
      if (Math.abs(P.dx) + Math.abs(P.dy) > 9) P.moved = true;
      if (!P.moved) return;
      if (S.z > 1) { S.tx = clamp(P.tx + P.dx, 0); S.ty = clamp(P.ty + P.dy, 1); put(false); }
      else { S.tx = P.dx; S.ty = 0; im.style.opacity = String(1 - Math.min(0.5, Math.abs(P.dx) / 700)); put(false); }
    });
    function up(e) {
      if (!P || e.pointerId !== P.id) return;
      var p = P, dt = Math.max(1, Date.now() - p.t); P = null;
      if (p.moved) {
        if (S.z > 1) return;
        im.style.opacity = '';
        if (Math.abs(p.dx) > 56 || (Math.abs(p.dx) > 24 && Math.abs(p.dx) / dt > 0.4)) go(p.dx < 0 ? 1 : -1); else { S.tx = 0; put(true); }
        return;
      }
      if (e.type === 'pointerup') tap(e.clientX, e.clientY, p.img);
    }
    st[A]('pointerup', up); st[A]('pointercancel', up);
    el[A]('click', function (e) {
      var b = e.target.closest ? e.target.closest('[data-v]') : null; if (!b) return;
      var k = b.getAttribute('data-v'); if (k === 'close') shut(); else if (k === 'prev') go(-1); else if (k === 'next') go(1);
    });
    el[A]('keydown', function (e) {
      if (e.key === 'Escape') { e.stopPropagation(); shut(); } else if (e.key === 'ArrowLeft') go(-1); else if (e.key === 'ArrowRight') go(1);
      trap(el, e);
    });
    function shut() {
      clearTimeout(timer); el.classList.remove('is-open', 'is-zoom'); el.setAttribute('aria-hidden', 'true'); H.classList.remove('wl-view-open'); H.style.overflow = '';
      var o = S.opener; S.opener = null; if (o && D.contains(o) && o.focus) { try { o.focus({ preventScroll: true }); } catch (x) { /* a courtesy */ } }
    }
    D.body.appendChild(el);
    vw = { el: el, S: S, show: show, shut: shut, xb: xb };
    return vw;
  }
  function openView(n, opener) {
    var list = viewList(); if (!list.length) return false;
    var v = viewer(); v.S.list = list; v.S.opener = opener || null;
    v.show(Math.max(0, Math.min(list.length - 1, n)), 0);
    v.el.classList.add('is-open'); v.el.setAttribute('aria-hidden', 'false'); H.classList.add('wl-view-open'); H.style.overflow = 'hidden';
    try { v.xb.focus({ preventScroll: true }); } catch (e) { /* focus is a courtesy */ }
    return true;
  }
  function viewClicks() {
    D[A]('click', function (e) {
      if (e.defaultPrevented || e.button > 0 || e.metaKey || e.ctrlKey || e.shiftKey) return;
      var b = e.target.closest ? e.target.closest('[data-wl-open]') : null, n = -1;
      if (b) n = Number(b.getAttribute('data-wl-open')) - 1;
      else {
        var w = e.target.closest ? e.target.closest('.wl-pdp .gallery__image-wrap') : null;
        if (w) { b = w; n = [].indexOf.call(D.querySelectorAll('.wl-pdp .gallery__image-wrap'), w); }
      }
      if (!b || n < 0) return;
      if (openView(n, b)) e.preventDefault();
    });
  }

  /* ------------------------------------------------------------------ the mini cart: bottom sheet (phone) / drawer (desktop) */
  var el = null, busy = false;
  var SVG = { x: '<path d="M6 6l12 12M18 6 6 18"/>', check: '<path d="m5 12.5 4.5 4.5L19 7.5"/>', truck: '<path d="M2.5 6.5h11v9h-11z"/><path d="M13.5 9.5h4l3 3.2v2.8h-7"/><circle cx="6.5" cy="17.5" r="1.8"/><circle cx="17" cy="17.5" r="1.8"/>',
              lock: '<rect x="5" y="10.5" width="14" height="10" rx="1.5"/><path d="M8 10.5V8a4 4 0 0 1 8 0v2.5"/>',
              left: '<path d="M15 5.5 8.5 12l6.5 6.5"/>', right: '<path d="m9 5.5 6.5 6.5L9 18.5"/>' };
  function icon(n, z) { return '<svg width="' + (z || 18) + '" height="' + (z || 18) + '" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false">' + SVG[n] + '</svg>'; }
  function build() {
    if (el && D.body.contains(el)) return el;
    var W = words(), P = PX + '-ui';
    el = D.createElement('div'); el.className = P; el.setAttribute('aria-hidden', 'true');
    el.innerHTML = '<div class="' + P + '__scrim" data-ui-close></div>' +
      '<aside class="' + P + '__panel" role="dialog" aria-modal="true" aria-labelledby="' + P + '-title" tabindex="-1"><div class="' + P + '__top">' +
      '<button type="button" class="' + P + '__grab" data-ui-close aria-label="' + esc(W.close) + '"><span></span></button>' +
      '<header class="' + P + '__head"><h2 class="' + P + '__title" id="' + P + '-title">' + esc(W.title) + '</h2><span class="' + P + '__count"></span>' +
      '<button type="button" class="' + P + '__x" data-ui-close aria-label="' + esc(W.close) + '">' + icon('x') + '</button></header></div>' +
      '<p class="' + P + '__added" role="status" hidden>' + icon('check', 16) + '<span>' + esc(W.added) + '</span></p>' +
      '<div class="' + P + '__body"></div><footer class="' + P + '__foot"></footer></aside>';
    el[A]('click', function (e) {
      if (e.target.closest('[data-ui-close]')) { close(); return; }
      var b = e.target.closest('[data-ui-act]'); if (!b || busy) return;
      var act = b.getAttribute('data-ui-act'), n = Number(b.getAttribute('data-qty'));
      change(b.getAttribute('data-key'), act === 'remove' ? 0 : (act === 'plus' ? n + 1 : n - 1), act);
    });
    el[A]('keydown', function (e) { if (e.key === 'Escape') { e.stopPropagation(); close(); } trap(el, e); });
    drag(el);
    D.body.appendChild(el); return el;
  }
  function drag(root) {   /* swipe the handle or the header down to close the sheet (phones only) */
    var panel = root.querySelector('.' + PX + '-ui__panel'), y0 = null, dy = 0, t0 = 0, mq = phone();
    function down(e) { if (!mq.matches || e.target.closest('[data-ui-act], .' + PX + '-ui__x')) return; y0 = e.clientY; dy = 0; t0 = Date.now(); panel.classList.add('is-drag'); try { e.currentTarget.setPointerCapture(e.pointerId); } catch (x) { /* optional */ } }
    function move(e) { if (y0 === null) return; dy = Math.max(0, e.clientY - y0); panel.style.transform = 'translateY(' + dy + 'px)'; }
    function up() { if (y0 === null) return; var v = dy / Math.max(1, Date.now() - t0); y0 = null; panel.classList.remove('is-drag'); panel.style.transform = ''; if (dy > 110 || (dy > 40 && v > 0.6)) close(); }
    [root.querySelector('.' + PX + '-ui__grab'), root.querySelector('.' + PX + '-ui__head')].forEach(function (h) { h[A]('pointerdown', down); h[A]('pointermove', move); h[A]('pointerup', up); h[A]('pointercancel', up); });
  }
  function change(key, qty, act) {
    busy = true; el.classList.add('is-busy');
    T().cart.change(key, Math.max(0, qty)).then(function () { return render(key, act); }).catch(function () {}).then(function () { busy = false; el.classList.remove('is-busy'); });
  }
  function isGift(i) { return i.properties && i.properties._free_product === 'true'; }
  function render(refocusKey, refocusAct) {
    var W = words(), P = PX + '-ui';
    return T().cart.get().then(function (c) {
      var body = el.querySelector('.' + P + '__body'), foot = el.querySelector('.' + P + '__foot');
      var new0 = lastAdded && lastAdded.items && lastAdded.items[0] ? lastAdded.items[0].key : null;
      el.querySelector('.' + P + '__count').textContent = c.items.length ? count(c.item_count, W) : '';
      if (!c.items.length) {
        body.innerHTML = '<div class="' + P + '__empty"><p>' + esc(W.empty) + '</p><a class="' + P + '__btn ' + P + '__btn--line" href="' + esc((T().routes && T().routes.all) || '/collections/all') + '" data-ui-close>' + esc(W.keep) + '</a></div>';
        foot.innerHTML = ''; foot.hidden = true; return;
      }
      foot.hidden = false;
      body.innerHTML = '<ul class="' + P + '__lines">' + c.items.map(function (i) {
        var v = i.variant_title && !/^default title$/i.test(i.variant_title) ? '<p class="' + P + '__meta">' + esc(i.variant_title) + '</p>' : '';
        var k = esc(i.key), ctl = isGift(i) ? '<span class="' + P + '__ro">× ' + i.quantity + '</span>' :
          '<div class="' + P + '__qty" role="group" aria-label="' + esc(W.qty) + '"><button type="button" data-ui-act="minus" data-qty="' + i.quantity + '" data-key="' + k + '" aria-label="' + esc(W.minus) + '">−</button>' +
          '<span aria-live="polite">' + i.quantity + '</span><button type="button" data-ui-act="plus" data-qty="' + i.quantity + '" data-key="' + k + '" aria-label="' + esc(W.plus) + '">+</button></div>' +
          '<button type="button" class="' + P + '__rm" data-ui-act="remove" data-qty="' + i.quantity + '" data-key="' + k + '">' + esc(W.remove) + '</button>';
        return '<li class="' + P + '__line' + (new0 && i.key === new0 ? ' is-new' : '') + '"><a class="' + P + '__pic" href="' + esc(i.url) + '" tabindex="-1" aria-hidden="true">' + pic(i.image, 80) + '</a>' +
          '<div class="' + P + '__info"><a class="' + P + '__name" href="' + esc(i.url) + '">' + esc(i.product_title) + '</a>' + v + '<div class="' + P + '__ctl">' + ctl + '</div></div>' +
          '<span class="' + P + '__price">' + money(i.final_line_price) + '</span></li>';
      }).join('') + '</ul>';
      foot.innerHTML = '<div class="' + P + '__sub"><span>' + esc(W.subtotal) + '</span><strong>' + money(c.total_price) + '</strong></div>' +
        '<wl-eta class="wl-eta wl-eta--line"><span class="wl-eta__ic" aria-hidden="true">' + icon('truck', 17) + '</span><span class="wl-eta__t"><span class="wl-eta__k">' + esc(W.eta) + '</span> <strong class="wl-eta__v" data-eta>' + esc(W.eta_fb) + '</strong></span></wl-eta>' +
        '<p class="' + P + '__ship">' + icon('truck') + '<span>' + esc(W.ship) + '</span></p>' +
        '<div class="' + P + '__acts"><a class="' + P + '__btn" href="' + esc(checkoutUrl()) + '">' + icon('lock') + '<span>' + esc(W.checkout) + '</span></a><a class="' + P + '__btn ' + P + '__btn--line" href="' + esc(cartUrl()) + '">' + esc(W.view_cart) + '</a></div>';
      if (refocusKey) {
        var again = el.querySelector('[data-key="' + refocusKey + '"][data-ui-act="' + refocusAct + '"]') || el.querySelector('[data-key="' + refocusKey + '"]') || el.querySelector('.' + P + '__x');
        if (again) again.focus();
      }
    });
  }
  function openUi(showAdded) {
    build(); lastFocus = D.activeElement;
    return render().then(function () {
      el.querySelector('.' + PX + '-ui__added').hidden = !showAdded;
      el.classList.add('is-open'); el.setAttribute('aria-hidden', 'false'); H.style.overflow = 'hidden';
      var b = el.querySelector('.' + PX + '-ui__x');
      if (b && b.offsetParent) b.focus({ preventScroll: true }); else { var p = el.querySelector('.' + PX + '-ui__panel'); if (p) p.focus({ preventScroll: true }); }
    });
  }
  function close() {
    if (!el) return;
    el.classList.remove('is-open'); el.setAttribute('aria-hidden', 'true'); H.style.overflow = '';
    if (lastFocus && lastFocus.focus && D.contains(lastFocus)) { try { lastFocus.focus({ preventScroll: true }); } catch (e) { /* focus is a courtesy */ } }
  }
  function afterAdd(after) {
    if (after === 'cart') return false;       /* the form asked for the cart page: let the theme go there */
    openUi(true).catch(function () {});
    return true;
  }
  function init() {
    viewClicks();
    D[A]('click', function (e) {
      if (e.defaultPrevented || e.button > 0 || e.metaKey || e.ctrlKey || e.shiftKey) return;
      var a = e.target.closest('.wl-top__cartlink'); if (!a) return;
      if (D.querySelector('boostly-cart-items')) return;   /* already on the cart page */
      e.preventDefault(); openUi(false).catch(function () {});
    });
    D[A]('keydown', function (e) { if (e.key === 'Escape' && el && el.classList.contains('is-open')) close(); });
  }

  start(function () {
    T().events.on('cart:added', function (e) { lastAdded = e.detail || null; });
    T().afterAddHook = function (after) { return afterAdd(after); };
    if (typeof init === 'function') init();
  });
})();

/* phone buy bar (<PX-mbar>) + cart checkout bar visibility */
(function () {
  'use strict';
  var PX = 'wl';
  function fmt(c) { try { return window.Theme.money.format(c); } catch (e) { return '$' + (Number(c || 0) / 100).toFixed(2); } }
  if (!customElements.get(PX + '-mbar')) customElements.define(PX + '-mbar', class extends HTMLElement {
    connectedCallback() {
      var self = this;
      this.main = document.querySelector('.' + PX + '-pdp .product-form__submit');
      if (!this.main || !('IntersectionObserver' in window)) return;
      this.io = new IntersectionObserver(function (es) {
        var e = es[0]; self.show(!e.isIntersecting && e.boundingClientRect.top < 0);
      });
      this.io.observe(this.main);
      this.addEventListener('click', function (e) {
        if (!e.target.closest('[data-mbar-add]') || self.main.disabled) return;
        self.main.click();
      });
      this.onVariant = function (e) {
        var v = e.detail && e.detail.variant; if (!v) return;
        var p = self.querySelector('[data-mbar-price]'), b = self.querySelector('[data-mbar-add]');
        if (p) p.textContent = fmt(v.price);
        if (b) { b.disabled = !v.available; b.textContent = v.available ? self.dataset.add : self.dataset.sold; }
      };
      document.addEventListener('variant:change', this.onVariant);
    }
    show(on) { this.classList.toggle('is-in', on); document.documentElement.classList.toggle(PX + '-has-mbar', on); }
    disconnectedCallback() {
      if (this.io) this.io.disconnect();
      if (this.onVariant) document.removeEventListener('variant:change', this.onVariant);
      document.documentElement.classList.remove(PX + '-has-mbar');
    }
  });
})();
